// extracted by mini-css-extract-plugin
export default {"root":"LI_nw0"};